module.exports = __webpack_public_path__ + "static/img/login_bg3.d32b706.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/login_bg3.jpg
// module id = 5Dgd
// module chunks = 128